module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo-block', {
    attrs: {
      "vue-code": _vm.code,
      "html-code": _vm.htmlCode
    }
  }, [_c('template', {
    slot: "preview"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._v("\n      Pano index:" + _vm._s(_vm.index) + "\n      "), _c('button', {
    on: {
      "click": _vm.change
    }
  }, [_vm._v("Toggle")])]), _vm._v(" "), _c('Pano', {
    attrs: {
      "source": _vm.urls[_vm.index]
    },
    on: {
      "on-load": _vm.onLoad
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "demo-loading"
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a5bfa54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demos/pages/demo-pano.vue
// module id = 327
// module chunks = 1